module.exports = "<template>\n  <hr class=\"listSelector_separator\"/>\n</template>";